import React from "react";
import { genURL, gengetURLTEST, genpostURL, genpostURLTEST } from './../_getjson';
import SelectFix from '../PopUp/SelectFix';
import PopUpOther from './../PopUp/PopUpOther';
import PopUpBankcontactsub from './../PopUp/PopUpGetBookno';
import PopUpCsbankcashin from './../PopUp/PopUpCsbankcashin';
import { ReDate } from './../_source/Datefn'
/* import PopUpSaveMoney from './../PopUp/PopUpSaveMoney'; */
import { DropdownButton, MenuItem, Row, Grid, Col, Panel } from "react-bootstrap";
import { parseJwt } from '../parseJWT';
import PopUpReport from "../PopUp/_fromShow";
import Checkdocgroup from './../CustomFunction/Docgroup/Checkdocgroup'
import Chackdocno from './../CustomFunction/Docno/GetDocno'
import CheckBrabchname from './../CustomFunction/Branch/Checkname'
import CheckDepartmentname from './../CustomFunction/Department/Checkname'
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import axios from 'axios'
import Snackbar from './../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import cheackdate from './../CustomFunction/Date/Checkdate'
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers"
import Topbar from "../Components/Customtopbar/Topbar";
import MGrid from '@mui/material/Grid';
import CustomInput from "../Components/CustomInput/CustomInput";
import Divider from '@mui/material/Divider';
import SelectDatas from "./../PopUp/SelectData"
import Rechecked from "./Components/Rechecked";
import CheckCodeDocGroup from "../CustomFunction/Docgroup/CheckCodeDocGroup";
import FullScreenDialog from '../PopUp/FullScreendialogs/FullScreen'

const listmenu = [["-", "-"]]
export default class Index extends React.Component {
    constructor(props) {
        super(props);
        this.Bookno = React.createRef();
        this.Bookno_code = React.createRef();
        this.Groupdata_code = React.createRef();
        this.Groupdata = React.createRef();
        this.Department_code = React.createRef();
        this.Department = React.createRef();
        this.Branch_code = React.createRef();
        this.Branch = React.createRef();
        this.DeliNumber = React.createRef();
        this.Remark = React.createRef();
        this.Sumpayamount = React.createRef();
        this.Depositpayment = React.createRef();
        this.Discamount = React.createRef();
        // this.Netpayamount = React.createRef();
        this.state = {
            Groupdata_txt: "",
            Department_txt: "",
            Branch_txt: "",
            Bookname: "",
            openBackdrop: false,
            autoClose: 3600,
            color: "warning",
            messagealert: "",
            roundData: "0",
            eamountData: "0",
            nioteData: "",
            PROJECT: "",
        }
    }
    _get_PopUpSaveMoney = (data1, data2, data3, data4, _orterExpenses) => {
        var split_data2 = data2.split("|");
        var CashReceipt = data1;
        var BOOKNO = split_data2[0];
        var BANKAMOUNT = split_data2[1];
        var BANKEXPEND = split_data2[2];
        var remarkcashreceipt = split_data2[3]
        if (data4 <= 0) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ไม่มียอดชำระ" })
            return;
        } else {
            this.saveData(CashReceipt, BOOKNO, BANKAMOUNT, BANKEXPEND, remarkcashreceipt, data3, data4, _orterExpenses);
        }
    }
    ResetThisPage = (type) => {
        if (type === "SAVE") {
            window.location.replace("/PSCsbankcashin");
        }
    }
    componentDidMount() {
        let SITECODESTR = parseJwt(localStorage.getItem('Token'));
        this.setState({ siteCodeUser: SITECODESTR.User.SITECODE });
        this.onAddValue("Branch", SITECODESTR.User.SITECODE);
    }

    SelectSetData = (type, data) => {
        switch (type) {
            case "Calendar1":
                this.setState({ Docdate: data })
                break;
            case "PROJECT":
                this.setState({ PROJECT: data })
                break;
            default: break;
        }
    }
    getBookBank = (code) => {
        this.setState({ openBackdrop: true })
        var url = "CSBANKCASHIN/GetBookno?Bookno=" + code + "&user=" + localStorage.getItem("Username");

        axios.get(genURL(url), { timeout: 6800 }).then(res => {
            if (res.data.length > 0) {
                this.setState({ Bookname: res.data[0].BOOKNAME });
                this.Bookno.current.value = res.data[0].BOOKNAME;
                this.Bookno_code.current.value = res.data[0].BOOKNO;
                this.setState({ openBackdrop: false })
            } else {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ไม่พบข้อมูล" })
                this.setState({ Bookname: "" });
                this.Bookno.current.value = "";
                this.Bookno_code.current.value = "";
                this.setState({ openBackdrop: false })
            }
        }).catch(error => {
            console.log(error);
            this.setState({ Bookname: "" });
            this.Bookno.current.value = "";
            this.Bookno_code.current.value = "";
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้" })
            this.setState({ openBackdrop: false })
        });



    }

    Switch_OtherPopup = (type) => {
        this.setState({ OtPopupType: type })
        this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
    }
    Switch_PopUpSaveMoney = (e) => {
        this.setState({ PopUpSaveMoney: !this.state.PopUpSaveMoney });
    }
    Get_PopUpOther = async (val) => {
        var data = val.split("|");
        for (var i = 0; i < data.length; i++) {
            data[i] = data[i].trim();
        }
        switch (this.state.OtPopupType) {
            case "Groupdata":
                this.Groupdata_code.current.value = data[0]
                this.Groupdata.current.value = data[1]
                this.setState({ Groupdata_txt: data[1] });
                await Chackdocno(data[0], "CSBANKCASHIN").then(async (result1) => {
                    console.log(result1);
                    if (result1 !== undefined) {
                        this.DeliNumber.current.value = await result1
                    } else {
                        this.DeliNumber.current.value = ""
                    }
                }).catch((err) => {
                    this.DeliNumber.current.value = ""
                    console.log(err);
                });
                break;
            case "Department":
                this.Department_code.current.value = await data[0];
                this.Department.current.value = await data[1];
                this.setState({ Department_txt: data[1] });
                break;
            case "Branch":
                this.Branch_code.current.value = await data[0];
                this.Branch.current.value = await data[1];
                this.setState({ Branch_txt: data[1] });
                break;
            default:
                break;
        }
    };
    onAddValue = async (type, value, Fix) => {
        if (value) {
            switch (type) {
                case "Groupdata":
                    this.setState({ openBackdrop: true })
                    Checkdocgroup(value, "CSBANKCASHIN").then(async (result) => {
                        if (result !== "") {
                            this.Groupdata_code.current.value = value
                            this.Groupdata.current.value = result
                            this.setState({ Groupdata_txt: result });
                            this.setState({ openBackdrop: false })
                            if (Fix !== "Y") {
                                await Chackdocno(value, "CSBANKCASHIN").then((result1) => {
                                    if (result1 !== "") {
                                        this.DeliNumber.current.value = result1
                                    } else {
                                        this.DeliNumber.current.value = ""
                                    }
                                }).catch((err) => {
                                    this.DeliNumber.current.value = ""
                                    console.log(err);
                                });
                            }
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Groupdata_code.current.value = ""
                            this.Groupdata.current.value = ""
                            this.setState({ Groupdata_txt: "" });
                            this.DeliNumber.current.value = ""
                            this.setState({ openBackdrop: false })
                        }
                    }).catch((err) => {
                        this.Groupdata_code.current.value = ""
                        this.Groupdata.current.value = ""
                        this.setState({ Groupdata_txt: "" });
                        this.DeliNumber.current.value = ""
                        console.log(err);
                    });
                    break;
                case "Department":
                    this.setState({ openBackdrop: true })
                    await CheckDepartmentname(value).then((result) => {
                        console.log(result);
                        if (result !== "") {
                            this.Department_code.current.value = value
                            this.Department.current.value = result
                            this.setState({ Department_txt: result });
                            this.setState({ openBackdrop: false })
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Department_code.current.value = ""
                            this.Department.current.value = ""
                            this.setState({ Department_txt: "" });
                            this.setState({ openBackdrop: false })
                        }
                    }).catch((err) => {
                        this.Department_code.current.value = ""
                        this.Department.current.value = ""
                        this.setState({ Department_txt: "" });
                        console.log(err);
                        this.setState({ openBackdrop: false })
                    });
                    break;
                case "Branch":
                    this.setState({ openBackdrop: true })
                    await CheckBrabchname(value).then((result) => {
                        if (result !== "") {
                            this.Branch_code.current.value = value
                            this.Branch.current.value = result
                            this.setState({ Branch_txt: result });
                            this.setState({ openBackdrop: false })
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Branch_code.current.value = ""
                            this.Branch.current.value = ""
                            this.setState({ Branch_txt: "" });
                            this.setState({ openBackdrop: false })
                        }
                    }).catch((err) => {
                        this.Branch_code.current.value = ""
                        this.Branch.current.value = ""
                        this.setState({ Branch_txt: "" });
                        console.log(err);
                        this.setState({ openBackdrop: false })
                    });
                    break;
            }
        }
    };

    reCheckData = async (type, val, fix) => {
        switch (type) {
            case "Groupdata":
                CheckCodeDocGroup(val, "CSBANKCASHIN").then((result) => {
                    console.log("result Groupdata", result);
                    this.Groupdata_code.current.value = val
                    this.Groupdata.current.value = result
                    this.setState({ Groupdata_txt: result });
                    this.setState({ Groupcode: val })
                    this.setState({ Groupname: result })
                }).finally(_ => {

                })
                break;
        }
    }

    reCHK = (RowData) => {
        this.closeDialog(false)
        var url = "CSBANKCASHIN/Getbycode?code=" + RowData[0].docNo;
        //  console.log(genURL(url));
        axios.get(genURL(url), { timeout: 3600 }).then(res => {
            console.log("res", res);
            if (res.data !== "") {
                this.setState({ Docdate: ReDate(res.data[0].DOCDATE) })
                this.DeliNumber.current.value = res.data[0].DOCNO;
                this.Remark.current.value = res.data[0].REMARK;
                this.Sumpayamount.current.value = res.data[0].AMOUNT;
                this.Depositpayment.current.value = res.data[0].EXPENSE1;
                this.Discamount.current.value = res.data[0].EXPENSE2;
                // this.Netpayamount.current.value = res.data[0].WTAXAMOUNT;
                // this.onAddValue("Groupdata", res.data[0].DOCGROUP, "Y")
                this.reCheckData("Groupdata", res.data[0].DOCGROUP, true)
                this.getBookBank(res.data[0].BOOKNO);
                this.onAddValue("Department", res.data[0].DEPARTMENT);
                this.onAddValue("Branch", res.data[0].SITECODE);
            }
        }).catch(error => {
            console.log(error);
        });
    }
    _print = (e) => {
        if (!this.DeliNumber.current.value) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกเลขที่เอกสาร" })
        } else {
            this._callForm(this.DeliNumber.current.value);
        }
    }
    _callForm = (vel) => {
        let url1 = "https://csrpt.pspl.co.th/jasperserver/flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report%2FPSMT_FROM&reportUnit=%2Freports%2FPSMT_report%2FPSMT_FROM%2FCSARRECEIPT&standAlone=true&api_key=0WXZeIZXvvbBEoIotvJSC7H3vXnoPfRul9xNdF1u&j_username=rpt&j_password=042615116&output=pdf&docno=" + vel;
        this.setState({ urlsend: url1 })
        setTimeout(() => {
            this.switchshowform();
        }, 100);
    }
    switchshowform = (e) => {
        this.setState({ showform: !this.state.showform });
    }
    Get_PopUpBankcontactsub = (data) => {
        console.log(data);
        this.setState({ Bookname: data.T_BOOKNAME });
        this.Bookno.current.value = data.T_BOOKNAME;
        this.Bookno_code.current.value = data.T_Bookno;
    }
    Switch_Bankcontactsub = () => {
        this.setState({ SwitBankcontact: !this.state.SwitBankcontact })
    }
    saveData = async () => {
        const parameter = new URLSearchParams();
        parameter.append("CREATEUSER", localStorage.getItem('Username'));
        parameter.append("UPDATEUSER", localStorage.getItem('Username'));
        parameter.append("DOCNO", this.DeliNumber.current.value); //เลขที่ใบโอน
        parameter.append("REMARK", this.Remark.current.value); //หมายเหตุ
        parameter.append("DOCGROUP", this.Groupdata_code.current.value); //กลุ่มข้อมูล
        parameter.append("BOOKNO", this.Bookno_code.current.value); //เลขที่บัญชี
        parameter.append("DEPARTMENT", this.Department_code.current.value);
        parameter.append("SITECODE", this.Branch_code.current.value);
        parameter.append("AMOUNT", this.Sumpayamount.current.value);

        parameter.append("EXPENSE1", this.Depositpayment.current.value === "" ? "0" : this.Depositpayment.current.value);
        parameter.append("EXPENSE2", this.Discamount.current.value === "" ? "0" : this.Discamount.current.value);
        parameter.append("WTAXAMOUNT", "0");
        parameter.append("OWNERCODE", localStorage.getItem('Username'));

        parameter.append("Round", this.state.roundData);
        parameter.append("EAmount", this.state.eamountData);
        parameter.append("Niote", this.state.nioteData);
        parameter.append("PROJECT", this.state.PROJECT)

        var Uststus = true;
        for (var pair of parameter.entries()) {
            console.log(pair);
            if (pair[1] === "" && pair[0] === "DOCGROUP") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกกลุ่มข้อมูล" })
                this.Groupdata.current.focus()
                break
            }
            else if (pair[1] === "" && pair[0] === "BOOKNO") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกเลขบัญชี" })
                this.Bookno.current.focus()
                break
            }
            else if (pair[1] === "" && pair[0] === "DEPARTMENT") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกแผนก" })
                this.Department.current.focus()
                break
            }
            else if (pair[1] === "" && pair[0] === "SITECODE") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกสาขา" })
                this.Branch.current.focus()
                break
            }
            else if (pair[1] === "" && pair[0] === "AMOUNT") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกยอดเงินนำฝาก" })
                this.Sumpayamount.current.focus()
                break
            }
        }
        if (Uststus === true) {
            this.setState({ openBackdrop: true })
            var url = "CSBANKCASHIN/Save?user=";
            await axios.post(genpostURL(url), parameter).then(res => {
                console.log(res.data);
                if (res.data === "Success") {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "success" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "บันทึกสำเร็จ" })
                    setTimeout(() => {
                        this.setState({ openBackdrop: false })
                        this.ResetThisPage("SAVE")
                    }, 30);
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "บันทึกไม่สำเร็จ" + res.data })
                    this.setState({ openBackdrop: false })
                }
            }).catch(error => {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
                this.setState({ openBackdrop: false })
            });
        }
    }
    Chackdoc = () => {
        Chackdocno(this.Groupdata_code.current.value, "CSBANKCASHIN").then(async (result1) => {
            if (result1 !== undefined) {
                this.DeliNumber.current.value = await result1
            } else {
                this.DeliNumber.current.value = ""
            }
        }).catch((err) => {
            this.DeliNumber.current.value = ""
            console.log(err);
        });
    }

    onClick = (e) => {
        if (e.target.value !== "") {
            switch (e.target.name) {
                case "Groupdata":
                    this.Groupdata.current.value = this.Groupdata_code.current.value
                    break;
                case "Bookno":
                    this.Bookno.current.value = this.Bookno_code.current.value
                    break;
                case "Department":
                    this.Department.current.value = this.Department_code.current.value
                    break;
                case "Branch":
                    this.Branch.current.value = this.Branch_code.current.value
                    break;
                default:
                    break;
            }
        }
    }
    onKeyDown = (e) => {
        if (e.key === "Enter") {
            if (e.target.name === "Groupdata") {
                this.onAddValue("Groupdata", e.target.value);
            }
            if (e.target.name === "Bookno") {
                this.getBookBank("Bookno", e.target.value);
            }
            console.log(e.target.name);
            if (e.target.name === "Department") {
                this.onAddValue("Department", e.target.value);
            }
            if (e.target.name === "Branch") {
                this.onAddValue("Branch", e.target.value);
            }
        }
    };
    onChange = (e) => {
        switch (e.target.name) {
            case 'Groupdata':
                if (e.target.value === "") {
                    this.setState({ Groupdata_txt: "" })
                    this.Groupdata_code.current.value = "";
                    this.DeliNumber.current.value = "";
                }
                break;
            case 'Bookno':
                if (e.target.value === "") {
                    this.setState({ Bookname: "" })
                    this.Bookno_code.current.value = ""
                }
                break;
            case 'Department':
                if (e.target.value === "") {
                    this.setState({ Department_txt: "" })
                    this.state.Department_txt = ""
                }
                break;
            case 'Branch':
                if (e.target.value === "") {
                    this.setState({ Branch_txt: "" })
                    this.Branch_code.current.value = ""
                }
                break;
            default:
                break;
        }
    }
    onBlur = (e) => {
        if (e.target.name === "Groupdata") {
            this.Groupdata.current.value = this.state.Groupdata_txt;
        }
        if (e.target.name === "Bookno") {
            this.Bookno.current.value = this.state.Bookname;
        }
        if (e.target.name === "Department") {
            this.Department.current.value = this.state.Department_txt;
        }
        if (e.target.name === "Branch") {
            this.Branch.current.value = this.state.Branch_txt;
        }
    };
    onClickTopbar = (e) => {
        console.log(e);
        switch (e) {
            case "save":
                this.saveData()
                break;
            case "new":
                this.ResetThisPage("SAVE")
                break;
            case "print":
                this._print(null)
                break;
            case "search":
                this.setState({ SwitchSearchDoc: true });
                break;
            default:
                break;
        }
    }

    closeDialog = (e) => {
        this.setState({ SwitchSearchDoc: e })
    }
    render() {
        return (
            <div className="PSApp" onClick={this.onClick} onKeyDown={this.onKeyDown} onChange={this.onChange} onBlur={this.onBlur} style={{ height: '600px' }}>
                {/* <div className="PSApp" onBlur={this.onBlur} onChange={this.onChange.bind(this)} onClick={this.onfocus.bind(this)}> */}
                <Backdrop open={this.state.openBackdrop} />
                <FullScreenDialog open={this.state.SwitchSearchDoc} title={"ค้นหารายการฝากเงิน"} closeDialog={e => this.closeDialog(e)}>
                    <Rechecked Dataselect={e => this.reCHK(e)} />
                </FullScreenDialog>
                {this.state.showform ? (<PopUpReport close={this.switchshowform} url={this.state.urlsend} />) : null}
                {/*  {this.state.PopUpSaveMoney ? <PopUpSaveMoney closePopup={this.Switch_PopUpSaveMoney} AmountPayable={this.state.AmountPayable} from="CSRECEIPT" get_PopUpSaveMoney={this._get_PopUpSaveMoney} pms="R|1|1|0|0|0|1" /> : null} */}
                {this.state.SwitchOtherPopup ? <PopUpOther closePopup={this.Switch_OtherPopup} type={this.state.OtPopupType} Get_PopUpOther={this.Get_PopUpOther} userSite="" from="CSBANKCASHIN" /> : null}
                {this.state.SwitBankcontact ? <PopUpBankcontactsub closePopup={this.Switch_Bankcontactsub} Get_PopUpBankcontactsub={this.Get_PopUpBankcontactsub} userSite="" from="CSBANKCASHIN" /> : null}
                <Topbar
                    listmenu={listmenu}
                    title="บันทึกฝากเงินสด"
                    onClick={e => this.onClickTopbar(e)}
                />
                <div className="PSAppfrom">
                    <Grid>
                        <Col xs={12} sm={8} md={8} lg={8}>
                            <Row className="show-grid">
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <Row className="show-grid">

                                        <MaterialUIPickers title="วันที่เอกสาร"
                                            DateValue={e => this.SelectSetData("Calendar1", e)}
                                            defaultdate={this.state.Docdate} />
                                    </Row>
                                </Col>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> กลุ่มข้อมูล</span>
                                                <input type="hidden" ref={this.Groupdata_code} />
                                                <input id="2" type="text" className="form-control " name="Groupdata" ref={this.Groupdata} />
                                                <span id="iconGroupdata" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "Groupdata")}>
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> หมายเหตุ</span>
                                                <input id="3" type="text" className="form-control " name="Remark" ref={this.Remark} tabIndex={3}
                                                    value={this.state.Remark} />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} sm={4} md={4} lg={4}>
                            <Row className="show-grid">
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> เลขที่เอกสาร</span>
                                                <input id="4" type="text" className="form-control " name="DeliNumber" ref={this.DeliNumber} disabled />
                                                <span id="iconTaxNumber" className="input-group-addon icon">
                                                    <i className="fas fa-sync-alt" onClick={() => this.Chackdoc()}></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> เลขที่บัญชี</span>
                                                <input type="hidden" ref={this.Bookno_code} />
                                                <input id="5" type="text" className="form-control " name="Bookno" ref={this.Bookno} />
                                                <span id="Docgroup" className="input-group-addon icon" onClick={this.Switch_Bankcontactsub.bind(null)} >
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Grid>
                    <Grid>
                        <Col xs={12} sm={8} md={8} lg={8}>
                            <Row className="show-grid">
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> แผนก</span>
                                                <input type="text" className="form-control hidden" ref={this.Department_code} readOnly />
                                                <input id="6" type="text" className="form-control " name="Department" ref={this.Department} />
                                                <span id="CSDEPARTMENT" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "Department")}>
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon">  สาขา</span>
                                                <input type="text" className="form-control hidden" ref={this.Branch_code} readOnly />
                                                <input id="7" type="text" className="form-control " name="Branch" ref={this.Branch} />
                                                <span id="sitecode" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "Branch")} >
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon width "> ยอดเงินนำฝาก</span>
                                                <input id="8" type="number" className="form-control Price" name="Sumpayamount" ref={this.Sumpayamount} />
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon width "> ค่าธรรมเนียมหักบัญชี</span>
                                                <input id="9" type="number" className="form-control Price" name="Depositpayment" ref={this.Depositpayment} />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} sm={4} md={4} lg={4}>
                            <Row className="show-grid">
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon width"> ค่าธรรมเนียมจ่ายเงินสด</span>
                                                <input id="10" type="number" className="form-control Price" name="Discamount" ref={this.Discamount} />
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <SelectDatas
                                                    origin="PROJECT"  // โครงการ
                                                    valueSelect={e => this.SelectSetData("PROJECT", e)} // รับค่ากลับ
                                                    title="โครงการ"
                                                    defaultselect={this.state.PROJECT}// ค่าเริ่มต้นของ โครงการ
                                                />
                                            </div>
                                        </div>
                                        {/* <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12' >
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon width "> ภาษีหัก ณ ที่จ่าย</span>
                                                <input id="11" type="text" className="form-control Price" name="Netpayamount" ref={this.Netpayamount} />
                                            </div>
                                        </div> */}
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Divider light />
                    </Grid>
                    <Grid style={{ marginTop: '20px' }}>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Row className="show-grid">
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Panel>
                                        <Panel.Heading>
                                            <Panel.Title componentClass="h5">ข้อมูลเพิ่มเติม ( User's Field) </Panel.Title>
                                        </Panel.Heading>
                                        <Panel.Body>
                                            <Col xs={12} sm={12} md={12} lg={12} >
                                                <Row className="show-grid">
                                                    <MGrid container spacing={1}>
                                                        <MGrid item xs={12} md={6} lg={3} xl={3}  >
                                                            <CustomInput label="รอบที่นำฝาก" inputType="number" id={"Round"} onChange={e => this.setState({ roundData: e })} />
                                                        </MGrid>
                                                        <MGrid item xs={12} md={4} lg={3} xl={3}  >
                                                            <CustomInput label="เงินคงเหลือสิ้นวัน" inputType="number" id={"EAmount"} onChange={e => this.setState({ eamountData: e })} />
                                                        </MGrid>
                                                        <MGrid item xs={12} md={6} lg={6} xl={6}  >
                                                            <CustomInput label="หมายเหตุ" inputType="text" id={"Niote"} onChange={e => this.setState({ nioteData: e })} />
                                                        </MGrid>
                                                    </MGrid>
                                                </Row>
                                            </Col>
                                        </Panel.Body>
                                    </Panel>
                                </Col>
                            </Row>
                        </Col>
                    </Grid>
                    <Snackbar place="br"
                        color={this.state.color}
                        icon={this.state.icon}
                        autoClose={this.state.autoClose}
                        message={this.state.messagealert}
                        open={this.state.opensnackbar}
                        closeNotification={() => { this.setState({ opensnackbar: false }) }}
                        close />
                </div>
            </div >
        );
    }
}